export const environment = {
  production: false,
  urlApi: "https://servicesapphcgecuador.reporteshcg.com/api/",
  urlApiColombia: "https://servicesapphcgecuador.reporteshcg.com/api/",
};
